module.exports = __webpack_public_path__ + "static/img/down-corner-8m-x-4m-inverted_256.421acb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-corner-8m-x-4m-inverted_256.png
// module id = W/dW
// module chunks = 0